export function findSketchDetailName(name) {
  if (name.match(/.*\//g) && name.match(/.*\//g)[0]) {
    return name.match(/.*\//g)[0].replace('/', '');
  }
  return name;
}
